import { render } from "./IconMail.vue?vue&type=template&id=2cb7a0ee"
import script from "./IconMail.vue?vue&type=script&lang=js"
export * from "./IconMail.vue?vue&type=script&lang=js"
script.render = render

export default script